import clsx from 'clsx';
import { useMessagesCountStore } from '@lib/store';
import { useTranslation } from 'react-i18next';

interface BurgerProps {
  isOpen: boolean;
  onClick: () => void;
}

export const Burger = (props: BurgerProps) => {
  const messagesCountStore = useMessagesCountStore();

  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        'hidden w-[60px] h-[60px] max-[840px]:flex items-center justify-center align-center fixed z-2 left-0 top-0  cursor-pointer',
        props.isOpen && 'max-[840px]:bg-[#27272b]',
      )}
      title={t('header.burger.title')}
      onClick={props.onClick}
    >
      {props.isOpen ? (
        <svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'>
          <path
            fill='#cfcfd4'
            d='M37.482 23.548L35.933 22l-6.192 6.193L23.548 22 22 23.548l6.193 6.193L22 35.933l1.548 1.549 6.193-6.193 6.192 6.193 1.549-1.549-6.193-6.192z'
          />
        </svg>
      ) : (
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='18 18 24 24'>
          <path fill='#dadada' d='M19 22h22v2H19zM19 29h22v2H19zM19 36h22v2H19z' />
        </svg>
      )}
      {!props.isOpen && !!messagesCountStore.data && (
        <div className='absolute right-[4px] top-[6px] height-[10px] min-w-[10px] leading-[10px] bg-[#d44112] rounded-[5px] text-[10px] center py-0 px-[4px]' />
      )}
    </div>
  );
};
